

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useState, useEffect } from "react";

import HomePageOne from "./pages/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/HomePageThree";
import HomePageFour from "./pages/HomePageFour";

import EmailPage from "./pages/EmailPage";
import AddUserPage from "./pages/AddUserPage";
import CalendarMainPage from "./pages/CalendarMainPage";
import ChatMessagePage from "./pages/ChatMessagePage";
import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPassowrdPage from "./pages/ResetPasswordPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";

import ThemePage from "./pages/ThemePage";
import ViewProfilePage from "./pages/ViewProfilePage";
import WidgetsPage from "./pages/WidgetsPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import SignalsFromTopTokenPage from "./pages/SignalsFromTopTokenPage";
import ShareholderPage from "./pages/Shareholders";

function App() {
  const imagePath2 = `${process.env.PUBLIC_URL}/assets/images/BlueAsterAR.png`;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1000); // Simulate a 1-second loading delay

    return () => clearTimeout(timeout);
  }, []);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <img className="loading-logo" 
          src={imagePath2} alt='' />
        <div className="loading-spinner"></div> 
      </div>
    );
  }

  return (
    <BrowserRouter basename="/corporate/onboarding" 
      future={{
        v7_startTransition: true, // Opt-in for startTransition
        v7_relativeSplatPath: true, // Opt-in for relative splat path
      }}>
      <RouteScrollToTop />
      <Routes>
        <Route exact path='/' element={<SignInPage />} />  {/* Signin Page */}
        <Route exact path='/dashboard' element={<HomePageOne />} />
        <Route exact path='/media-articles' element={<HomePageTwo />} />    {/*Media news */}
        {/* <Route exact path="/ai-bot" element={<HomePageFour />} /> */}
        <Route exact path='/news&updates' element={<HomePageThree />} />  {/*Crypto news */}
        <Route exact path='/documents' element={<CalendarMainPage />} />
        <Route exact path='/bank-documents' element={<ChatMessagePage />} />
        <Route exact path="/shareholders" element={<ShareholderPage/>} />
        <Route exact path='/company-info' element={<EmailPage />} />  {/* Basic info */}
        {/* <Route exact path='/crypto-signals' element ={<SignalsFromTopTokenPage/>} /> */}

        {/* SL */}
        <Route exact path='/add-user' element={<AddUserPage />} />
        <Route exact path='/calendar' element={<CalendarMainPage />} />    {/* Documents */}
        <Route exact path='/forgot-password' element={<ForgotPasswordPage />} />
        <Route exact path='/forgot-password/token?' element ={<ResetPassowrdPage />} />
        <Route exact path='/change-password' element={<ChangePasswordPage />} />
        <Route exact path='/sign-up' element={<SignUpPage />} />
   
        <Route exact path='*' element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

        
